/**
 * emitVisualPlan — fire a cast's visual plan on the EventBus (plan 29 F5).
 * Immediate entries emit now; delayed ones on a timer. `decorate` lets the
 * remote player stamp `origin: 'remote'` on its spawns; `timers` collects the
 * timer handles so an owner can cancel them on teardown.
 */
import { EventBus } from '../../../shared/EventBus';
import type { VisualEmit } from './castVisualPlan';

export function emitVisualPlan(
  plan: readonly VisualEmit[],
  opts: { decorate?: (e: VisualEmit) => VisualEmit; timers?: Set<ReturnType<typeof setTimeout>> } = {},
): void {
  const bus = EventBus.getInstance();
  for (const raw of plan) {
    const e = opts.decorate ? opts.decorate(raw) : raw;
    const fire = () => bus.emit(e.event, e.payload as never);
    if (e.delayMs > 0) {
      const t = setTimeout(() => { opts.timers?.delete(t); fire(); }, e.delayMs);
      opts.timers?.add(t);
    } else {
      fire();
    }
  }
}
